import { SVGAttributes } from 'react';

import { DoublyLinkedDatapoint } from 'types/charts';

type IsolatedEntryDotProps<T> = {
  payload?: DoublyLinkedDatapoint<T>;
  dataKey?: keyof T;
  svgProps?: SVGAttributes<SVGCircleElement>;
  cx?: number;
  cy?: number;
  stroke?: string;
};

/**
 * Custom dot that will be visible only when datapoint is isolated
 */
export const IsolatedEntryDot = <T,>({
  cx,
  cy,
  stroke,
  payload,
  dataKey,
  svgProps,
}: IsolatedEntryDotProps<T>) => {
  if (!payload || !dataKey) {
    return null;
  }

  const prev = payload.prev?.[dataKey];
  const next = payload.next?.[dataKey];
  const value = payload[dataKey];

  if (!!value && !prev && !next) {
    return (
      <circle cx={cx} cy={cy} r={1} fill={stroke} stroke="none" {...svgProps} />
    );
  }

  return null;
};
